import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../lib/axios';

export default class AttachmentUploaderInput extends Component {
  static propTypes = {
    endpoint: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onUploadComplete: PropTypes.func,
    maxSize: PropTypes.number,
    extensions: PropTypes.array,
  }

  static defaultProps = {
    value: null,
    defaultValue: null,
    onUploadComplete: null,
    required: false,
    maxSize: 25000000,
    extensions: [
      'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
      'numbers', 'pages', 'key',
      'jpg', 'jpeg', 'png', 'gif',
      'mkv', 'avi', 'mp4', 'm4v', 'mov',
      'zip', 'pdf',
    ],
  }

  constructor(props) {
    super(props);

    this.state = {
      id: this.props.value || this.props.defaultValue || '',
      percent: 0,
    };
  }

  componentDidMount() {
    console.log('didmount');
    if (this.props.value && this.props.value !== '') {
      console.log('axios');
      axios
        .get(`${this.props.endpoint}/${this.props.value}.json`)
        .then((response) => {
          this.setState({ fileName: response.data.filename });
        });
    }
  }

  validateFile(file) {
    const splits = file.name.split('.');
    const extension = splits[splits.length - 1];
    if (!extension || this.props.extensions.indexOf(extension.toLowerCase()) === -1) {
      this.setState({ error: 'Invalid file type. Please upload only image, document or video files.' });
      return false;
    }

    if (file.size > this.props.maxSize) {
      this.setState({ error: 'File too large' });
      return false;
    }
    this.setState({ error: null });
    return true;
  }

  handleFile = (e) => {
    const formData = new FormData();
    const fileList = e.target.files;
    if (fileList.length > 0) {
      // file selected
      const file = fileList[0];

      if (this.validateFile(file)) {
        // valid file
        formData.append('file', file, file.name);
        formData.append('upload_file', true);
        let sOutput = '';
        const aMultiples = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        for (let nMultiple = 0, nApprox = file.size / 1024; nApprox > 1; nApprox /= 1024, nMultiple += 1) {
          sOutput = `${nApprox.toFixed(3)} ${aMultiples[nMultiple]}`;
        }
        this.setState({ fileName: file.name, fileSize: sOutput });

        this.uploadFile(formData);
      } else {
        // invalid file
      }
    } else {
      // no file selected
    }
  }

  uploadFile(formData) {
    $.ajax({
      type: 'POST',
      url: this.props.endpoint,
      xhr: () => {
        const myXhr = $.ajaxSettings.xhr();
        if (myXhr.upload) {
          myXhr.upload.addEventListener('progress', this.progressHandling, false);
        }
        return myXhr;
      },
      success: (data) => {
        // your callback here
        this.setState({ percent: 100, id: data.id });
        if (this.props.onUploadComplete) {
          this.props.onUploadComplete(data.id);
        }
      },
      error: () => {
        // handle error
        this.setState({ percent: 0, id: '' });
        if (this.props.onUploadComplete) {
          this.props.onUploadComplete(null);
        }
      },
      async: true,
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      timeout: 60000,
    });
  }

  resetFile = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ fileName: null, percent: 0, error: null, id: '' });
  }

  progressHandling = (event) => {
    let percent = 0;
    const position = event.loaded || event.position;
    const total = event.total;
    if (event.lengthComputable) {
      percent = Math.ceil(position / (total * 100));
    }
    this.setState({ percent });
  }

  render() {
    const inputId = `attachment-${this.props.name}`;
    const hidden = { display: 'none' };
    let progress = null;
    if (this.state.percent > 0 && this.state.percent <= 100) {
      progress = (<span className="u-text-old-dark-grey"> : {this.state.percent}%</span>);
    }

    let fileInfo = null;
    if (this.state.fileName) {
      fileInfo = (
        <span className="u-text-old-dark-grey">
          {this.state.fileName}{!!this.state.fileSize && (<> - {this.state.fileSize}</>)}
        </span>);
    }

    let error = null;
    if (this.state.error) {
      error = (<span className="u-text-old-dark-grey">{this.state.error}</span>);
    }

    let selectFile = null;
    if (!fileInfo && !progress) {
      selectFile = (
        <label htmlFor={inputId}>
          <input type="file" id={inputId} style={hidden} onChange={this.handleFile} />
          <span className="Button Button--xsmall">
            <i className="Icon Icon-upload" /> Select file
          </span>
        </label>
      );
    }

    let discard = null;
    if (!selectFile) {
      discard = (<a onClick={this.resetFile} >&times;</a>);
    }

    const inputClasses = ['input', 'file'];
    if (this.props.required) {
      inputClasses.push('required');
    }
    const inputClass = inputClasses.join(' ');

    return (
      <div>
        {selectFile}
        {discard} {error} {fileInfo} {progress}
        <input type="hidden" name={this.props.name} className={inputClass} value={this.state.id} />
      </div>
    );
  }

}
